import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from "formik";
import CAT_CONSTANTS from 'lookup/CatConstants';
import { Form } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import FormGroup from 'react-bootstrap/FormGroup';
import FormLabel from 'react-bootstrap/FormLabel';
import Row from 'react-bootstrap/Row';
import { resetDsgSubmitRequest, submitDsg } from 'views/Cat/DynamicSwitchGroup/DynamicSwitchGroup.action';
import * as Yup from 'yup';
import DescriptionField from "../../commons/fields/DescriptionField";
import withRouter from 'utils/withRouter';

const DynamicSwitchGroupForm = ({ codexVersionId, history }) => {
  const dispatch = useDispatch();
  
  // Get state from Redux using useSelector
  const dynamicSwitchGroupId = useSelector((state) => 
    state.dynamicSwitchGroup.dynamicSwitchGroupId
  );
  const groupName = useSelector((state) => state.dynamicSwitchGroup.groupName);
  const additionalClassname = useSelector((state) => state.dynamicSwitchGroup.additionalClassname);
  const groupClassname = useSelector((state) => state.dynamicSwitchGroup.groupClassname);
  const groupSubClassname = useSelector((state) => state.dynamicSwitchGroup.groupSubClassname);
  const activeRadarClassname = useSelector((state) => state.dynamicSwitchGroup.activeRadarClassname);
  const notes = useSelector((state) => state.dynamicSwitchGroup.notes);
  const [localCodexVersionId] = useState(codexVersionId);
  
  useEffect(() => {
    return () => {
      dispatch(resetDsgSubmitRequest());
    };
  }, [dispatch]);
  useEffect(() => {
    if (dynamicSwitchGroupId) {
      history.push(`/cat/dynamic-switch-groups/${dynamicSwitchGroupId}`);
    }
  }, [dynamicSwitchGroupId, history]);

  const submitDynamicSwitchGroup = (values, setSubmitting) => {
    let dsgDto = {
      "dynamicSwitchGroupName": values.groupName || "",
      "dynamicSwitchGroupClassName": values.groupClassname || "",
      "dynamicSwitchGroupSubClassName": values.groupSubClassname || "",
      "additionalClassName": values.additionalClassname || "",
      "activeRadarClassname": values.activeRadarClassname,
      "isActive": "false",
      "isDeleted": "false",
      "pharmacistNotes": values.notes || ""
    };
    setSubmitting(false);
    dispatch(submitDsg(dsgDto, localCodexVersionId));
  };

  const isFieldRequired = (key) => {
    const DrugGroupSchema = Yup.object().shape({
      groupName: Yup.string()
        .max(255, CAT_CONSTANTS.fieldMaxLengthValidationPrefix + 255)
        .required("Required"),
      additionalClassname: Yup.string()
        .max(255, CAT_CONSTANTS.fieldMaxLengthValidationPrefix + 255),
      groupClassname: Yup.string()
        .max(255, CAT_CONSTANTS.fieldMaxLengthValidationPrefix + 255),
      groupSubClassname: Yup.string()
        .max(255, CAT_CONSTANTS.fieldMaxLengthValidationPrefix + 255),
      activeRadarClassname: Yup.string()
        .max(255, CAT_CONSTANTS.fieldMaxLengthValidationPrefix + 255),
      notes: Yup.string()
        .max(1024, CAT_CONSTANTS.fieldMaxLengthValidationPrefix + 1024),
    });
    return DrugGroupSchema.fields[key]
      ? DrugGroupSchema.fields[key].exclusiveTests.required
      : false;
  }
  const DrugGroupSchema = Yup.object().shape({
    groupName: Yup.string()
      .max(255, CAT_CONSTANTS.fieldMaxLengthValidationPrefix + 255)
      .required("Required"),
    additionalClassname: Yup.string()
      .max(255, CAT_CONSTANTS.fieldMaxLengthValidationPrefix + 255),
    groupClassname: Yup.string()
      .max(255, CAT_CONSTANTS.fieldMaxLengthValidationPrefix + 255),
    groupSubClassname: Yup.string()
      .max(255, CAT_CONSTANTS.fieldMaxLengthValidationPrefix + 255),
    activeRadarClassname: Yup.string()
      .max(255, CAT_CONSTANTS.fieldMaxLengthValidationPrefix + 255),
    notes: Yup.string()
      .max(1024, CAT_CONSTANTS.fieldMaxLengthValidationPrefix + 1024),
  });

  return (
      <Container fluid className='top-spacer'>
        <Row>
          <Col md={{ span: 10, offset: 1 }}>
            <div>
              <Card variant="primary">
                <Card.Header>
                  <Card.Title className="text-center"><h4>Dynamic Switch Group </h4></Card.Title>
                </Card.Header>
                <Card.Body>
                  <Formik
                    initialValues={{
                      groupName: groupName || "",
                      additionalClassname: additionalClassname || "",
                      groupClassname: groupClassname || "",
                      groupSubClassname: groupSubClassname || "",
                      activeRadarClassname: activeRadarClassname || "",
                      notes: notes || ""
                    }}
                    validationSchema={DrugGroupSchema}
                    onSubmit={(values, { setSubmitting }) => {
                      submitDynamicSwitchGroup(values, setSubmitting);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleBlur,
                      handleChange,
                      handleSubmit,
                      handleReset,
                      isSubmitting
                    }) => (
                      <Form onSubmit={handleSubmit} onReset={handleReset}>
                        <Row>
                          <Col md={12}>
                            <div className="small-top-spacer">
                              <Row>
                                <Col md={12}>
                                  <FormGroup as={Row} style={{ marginBottom: '0rem' }}>
                                    <Col md={3} style={{ paddingTop: '26px' }}>
                                      <FormLabel>Group Name*</FormLabel>
                                    </Col>
                                    <Col md={9}>
                                      <DescriptionField
                                        isEditMode={true}
                                        //name={"Group Name"}
                                        id={"groupName"}
                                        error={errors.groupName && touched.groupName && errors.groupName}
                                        savedValue={groupName}
                                        updatedValue={values.groupName}
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        isFieldRequired={isFieldRequired}
                                        compKey={"dsg-form-group-name"}
                                      />
                                    </Col>
                                  </FormGroup>
                                  <FormGroup as={Row} style={{ marginBottom: '0rem' }}>
                                    <Col md={3} style={{ paddingTop: '26px' }}>
                                      <FormLabel>Group Classname</FormLabel>
                                    </Col>
                                    <Col md={9}>
                                      <DescriptionField
                                        isEditMode={true}
                                        // name={"Group Classname"}
                                        id={"groupClassname"}
                                        error={errors.groupClassname && touched.groupClassname && errors.groupClassname}
                                        savedValue={groupClassname}
                                        updatedValue={values.groupClassname}
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        isFieldRequired={isFieldRequired}
                                        compKey={"dsg-form-group-classname"}
                                      />
                                    </Col>
                                  </FormGroup>
                                  <FormGroup as={Row} style={{ marginBottom: '0rem' }}>
                                    <Col md={3} style={{ paddingTop: '26px' }}>
                                      <FormLabel>Additional Classname</FormLabel>
                                    </Col>
                                    <Col md={9}>
                                      <DescriptionField
                                        isEditMode={true}
                                        //name={"Additional Classname"}
                                        id={"additionalClassname"}
                                        error={errors.additionalClassname && touched.additionalClassname && errors.additionalClassname}
                                        savedValue={additionalClassname}
                                        updatedValue={values.additionalClassname}
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        isFieldRequired={isFieldRequired}
                                        compKey={"dsg-form-additional-classname"}
                                      />
                                    </Col>
                                  </FormGroup>
                                  <FormGroup as={Row} style={{ marginBottom: '0rem' }}>
                                    <Col md={3} style={{ paddingTop: '26px' }}>
                                      <FormLabel>Group Sub-Classname</FormLabel>
                                    </Col>
                                    <Col md={9}>
                                      <DescriptionField
                                        isEditMode={true}
                                        //name={"Group Sub-Class Name"}
                                        id={"groupSubClassname"}
                                        error={errors.groupSubClassname && touched.groupSubClassname && errors.groupSubClassname}
                                        savedValue={groupSubClassname}
                                        updatedValue={values.groupSubClassname}
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        isFieldRequired={isFieldRequired}
                                        compKey={"dsg-form-group-sub-classname"}
                                      />
                                    </Col>
                                  </FormGroup>
                                  <FormGroup as={Row} style={{ marginBottom: '0rem' }}>
                                    <Col md={3} style={{ paddingTop: '26px' }}>
                                      <FormLabel>Active Radar Classname</FormLabel>
                                    </Col>
                                    <Col md={9}>
                                      <DescriptionField
                                        isEditMode={true}
                                        // name={"Active Radar Classname"}
                                        id={"activeRadarClassname"}
                                        error={errors.activeRadarClassname && touched.activeRadarClassname && errors.activeRadarClassname}
                                        savedValue={activeRadarClassname}
                                        updatedValue={values.activeRadarClassname}
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        isFieldRequired={isFieldRequired}
                                        compKey={"dsg-form-active-radar-classname"}
                                      />
                                    </Col>
                                  </FormGroup>
                                  <FormGroup as={Row}>
                                    <Col md={3} style={{ paddingTop: '26px' }}>
                                      <FormLabel>Pharmacist Notes</FormLabel>
                                    </Col>
                                    <Col md={9}>
                                      <DescriptionField
                                        isEditMode={true}
                                        //name={"Notes"}
                                        id={"notes"}
                                        error={errors.notes && touched.notes && errors.notes}
                                        savedValue={notes}
                                        updatedValue={values.notes}
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        isFieldRequired={isFieldRequired}
                                        compKey={"dsg-form-notes"}
                                        controlProps={{
                                          as: "textarea",
                                          rows: 1
                                        }}
                                      />
                                    </Col>
                                  </FormGroup>
                                </Col>
                                <Col md={{ span: 3, offset: 9 }}>
                                  <Button type="submit" block disabled={isSubmitting} className="btn-block mt-1">
                                    {
                                      isSubmitting ? 'Submitting... ' : 'Submit'
                                    }
                                  </Button>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    )}
                  </Formik>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>
      </Container >
  )
}

export default withRouter(DynamicSwitchGroupForm);

